import { setCountryOptionsI18n } from "explorer/reducers/countries";
import { setGenreOptionsI18n } from "explorer/reducers/generos";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

function I18nLayout({ children }: { children: React.ReactNode }) {
  const { genres } = useSelector((state: any) => state.genres);
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setGenreOptionsI18n(i18n.language));
  }, [i18n, dispatch, genres]);

  useEffect(() => {
    dispatch(setCountryOptionsI18n(i18n.language));
  }, [i18n, dispatch]);

  return <>{children}</>;
}

export default I18nLayout;
